import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { AppService } from '../../../services/app.service';
import { ActivatedRoute } from '@angular/router';
import { ActionButton } from '../../../models/app/action-button';
import { Subject } from 'rxjs';
import { NodesService } from '../../../services/nodes/nodes.service';
import { NodeFactory } from '../../../utilities/node-factory';

@Component({
    selector: 'app-navlet',
    templateUrl: './navlet.component.html',
    styleUrls: ['../../../app.component.css', './navlet.component.css']
})

export class NavletComponent implements OnInit, OnDestroy {

    public nodeId: number = 0;
    public node: any = null;
    public activatedRoute: ActivatedRoute;

    @HostBinding("class.component-flex-vertical-fill") addClass = true;

    private destroy = new Subject<void>();

    public constructor(public appService: AppService, private nodeService: NodesService, private route: ActivatedRoute) {

        this.activatedRoute = route;
        const parameters = this.route.params;

        if (parameters != null) {

            parameters.subscribe((p) => {

                this.nodeId = p["nodeid"];

                if (this.nodeService.currentNodes) {

                    this.node = NodeFactory.getNodeById(this.nodeId, this.nodeService.currentNodes);
                }
            });
        }
    }

    public ngOnInit(): void {

        // setup actions
        let actionButtons: ActionButton[] = [];

        //actionButtons.push(new ActionButton("APP FEED", "", "", ""));

        this.appService.setActionsDataSource(actionButtons);
    }

    public ngOnDestroy() {

        this.appService.setActionsDataSource([]);
        this.destroy.next();
        this.destroy.complete();
    }
}
